import { createFileRoute } from "@tanstack/react-router";
import { VoucherScreen } from "@/components/Voucher/VoucherScreen";
import { requireAuth } from "@/lib/guards";

export const Route = createFileRoute("/$locale/$partner/voucher/$voucherCode")({
	beforeLoad: requireAuth,
	component: VoucherRoute,
});

function VoucherRoute() {
	const { voucherCode } = Route.useParams();

	return <VoucherScreen voucherCode={voucherCode ?? ""} />;
}
